import { cn } from "app/lib/utils"
import {
  TOOLBAR_BUTTON_SIZE_CLASS,
  type ToolbarButtonSize,
} from "app/player/controlSizes"
import { cva, type VariantProps } from "class-variance-authority"
import { Toolbar } from "radix-ui"
import { ComponentProps, forwardRef } from "react"

export const toolbarIconButtonVariants = cva(
  "inline-flex shrink-0 items-center justify-center rounded-[12px] text-[length:inherit] outline-none transition-colors select-none focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      size: TOOLBAR_BUTTON_SIZE_CLASS,
    },
    defaultVariants: {
      size: "md",
    },
  }
)

type Props = Omit<ComponentProps<typeof Toolbar.Button>, "size"> &
  VariantProps<typeof toolbarIconButtonVariants> & {
    size?: ToolbarButtonSize
  }

const ToolbarIconButton = forwardRef<HTMLButtonElement, Props>(
  ({ className, size = "md", ...props }, ref) => {
    return (
      <Toolbar.Button
        ref={ref}
        className={cn(toolbarIconButtonVariants({ size }), className)}
        {...props}
      />
    )
  }
)

ToolbarIconButton.displayName = "ToolbarIconButton"

export default ToolbarIconButton
